module.exports = __webpack_public_path__ + "static/media/zaddons_logo.142a0726.png";